module.exports = __webpack_public_path__ + "shell/assets/images/pl/rancher-logo.svg";